// === NAPOSLEDY ZOBRAZENÉ PRODUKTY ===

const domainKey = window.location.hostname;
const storageKey = `recentProducts_${domainKey}`;
const maxProducts = 10;

// --- Pomocné funkce ---
function getStoredProducts() {
  try {
    return JSON.parse(localStorage.getItem(storageKey)) || [];
  } catch {
    return [];
  }
}

function saveStoredProducts(data) {
  localStorage.setItem(storageKey, JSON.stringify(data));
}

function normalizeOriginalImageSrc(src) {
  return (src || "").replace("/related/", "/orig/");
}

function normalizeProductUrl(url) {
  if (!url) return "";

  try {
    const parsed = new URL(url, window.location.origin);
    parsed.hash = "";
    parsed.search = "";
    parsed.pathname = parsed.pathname.replace(/\/+$/, "") || "/";
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    return (url || "").split("#")[0].split("?")[0];
  }
}

function getProductIdentity(product) {
  const productId = String(product?.product_id || product?.productId || "").trim();
  if (productId) return `id:${productId}`;

  const normalizedUrl = normalizeProductUrl(product?.url || "");
  if (normalizedUrl) return `url:${normalizedUrl}`;

  return "";
}

function splitVariantDiscountText(text) {
  const normalized = (text || "").replace(/\s+/g, " ").trim();
  if (!normalized) return null;

  const value = normalized.replace(/^až\s*/i, "").trim();
  if (!value) return null;

  return {
    value,
  };
}

function getVariantDiscountText(product) {
  if (product.variantDiscountText) return product.variantDiscountText;
  if (!product.flagsExtra) return "";

  const $tmp = $("<div></div>").html(product.flagsExtra);
  return (
    $tmp
      .find(".flag-discount .price-save .parameter-dependent.default-variant")
      .first()
      .text()
      .trim() || ""
  );
}

function getFlagsExtraHtml(product) {
  if (!product.hasVariants) return product.flagsExtra || "";

  const discountText = getVariantDiscountText(product);
  const parts = splitVariantDiscountText(discountText);
  if (!parts) return product.flagsExtra || "";

  return `<span class="flag flag-discount">až <span class="price-save">${parts.value}</span></span>`;
}

function getDetailAvailabilityData() {
  const $availability = $(".product-top .availability-value").first();
  if (!$availability.length) {
    return { label: "", amount: "", color: "" };
  }

  const $variantWithAmount = $availability
    .find(".parameter-dependent")
    .filter(function () {
      return $(this).find(".availability-amount").length > 0;
    })
    .first();
  const $source = $variantWithAmount.length
    ? $variantWithAmount
    : $availability;

  const $label = $source.find(".availability-label").first();
  const $amount = $source.find(".availability-amount").first();

  const rawLabel = ($label.text() || $source.text() || "").trim();
  const rawAmount = ($amount.text() || "").trim();
  const normalizedAmount = rawAmount.replace(/^\((.*)\)$/, "$1").trim();
  const color =
    ($label.attr("style") || $amount.attr("style") || "")
      .match(/color\s*:\s*([^;]+)/i)?.[1]
      ?.trim() || "";

  return {
    label: rawLabel,
    amount: normalizedAmount,
    color,
  };
}

function getAvailabilityHtml(product) {
  const label = (product.availabilityLabel || "").trim();
  const amount = (product.availabilityAmount || "").trim();
  const color = (product.availabilityColor || "").trim();

  if (!label && !amount) return "";

  const wrapperStyle = color ? ` style="color:${color}"` : "";
  const labelStyle = color ? ` style="color:${color}"` : "";

  return `<div class="availability"${wrapperStyle}><span${labelStyle}>${label}</span>${amount ? `<span class="availability-amount" data-testid="numberAvailabilityAmount">${amount}</span>` : ""}</div>`;
}

function addProductToStorage() {
  const availabilityData = getDetailAvailabilityData();
  const product = {
    url: document.location.href,
    domain: domainKey,
    name: $(".p-detail>.p-detail-inner>.p-detail-inner-header>h1")
      .text()
      .trim(),
    image: $(".p-image-wrapper .p-image").find("img").first().attr("src"),
    secondImage: normalizeOriginalImageSrc(
      $(".p-thumbnails-inner .p-thumbnail:eq(1) img").attr("data-src"),
    ),
    price: $(".price-final-holder").first().text().trim(),
    priceStandard:
      $(".p-image .price-standard span").first().text().trim() || "",
    product_id: $("input[name=productId]").val() || "",
    priceId: $("input[name=priceId]").val() || "",
    hasVariants: $(".variant-list").length > 0,
    flags: $(".p-detail-info .flags-default").html() || "",
    flagsExtra: $(".p-image .flags.flags-extra").html() || "",
    variantDiscountText:
      $(
        ".p-image .flag-discount .price-save .parameter-dependent.default-variant",
      )
        .first()
        .text()
        .trim() || "",
    availabilityLabel: availabilityData.label,
    availabilityAmount: availabilityData.amount,
    availabilityColor: availabilityData.color,
  };
  const productIdentity = getProductIdentity(product);
  let stored = getStoredProducts();

  if (productIdentity) {
    stored = stored.filter((p) => getProductIdentity(p) !== productIdentity);
  }

  const seen = new Set();
  stored = stored.filter((p) => {
    const identity = getProductIdentity(p);
    if (!identity) return true;
    if (seen.has(identity)) return false;
    seen.add(identity);
    return true;
  });

  stored.unshift(product);
  if (stored.length > maxProducts) stored = stored.slice(0, maxProducts);
  saveStoredProducts(stored);
}

function renderRecentlyViewed(full = false) {
  const storedProducts = getStoredProducts();
  if (!storedProducts.length) return;
  const productsToRender = full ? storedProducts : storedProducts.slice(0, 4);

  const isRecentlyViewedPage =
    window.location.pathname === "/naposledy-prohlizene/";

  const rvContainer = $(`
    <div id="rvRecentlyViewed" class="rvRecentlyViewed ${isRecentlyViewedPage ? "rvRecentlyViewedPage" : "in-index"}">
      <div class="rvList products-block products"></div>
    </div>
  `);

  const $target = isRecentlyViewedPage
    ? $('.pageArticleDetail [itemprop="about"]').first()
    : $(".lastWiewProducts").first();

  if (!$target.length) return;

  if (!$target.find("#rvRecentlyViewed").length) {
    $target.append(rvContainer);
  }

  const $rvList = $target.find("#rvRecentlyViewed .rvList");

  productsToRender.forEach((p) => {
    const product = {
      ...p,
      image: p.image || p.img || "",
      secondImage: p.secondImage || p.second_image || "",
      price:
        typeof p.price === "string"
          ? p.price
          : p.price?.final
            ? $("<div></div>").html(p.price.final).text().trim()
            : "",
      priceStandard:
        p.priceStandard ||
        (p.price?.standard
          ? $("<div></div>").html(p.price.standard).text().trim()
          : ""),
      product_id: p.product_id || p.productId || "",
      priceId: p.priceId || p.price_id || "",
      flags: p.flags || p.label || "",
      hasVariants:
        typeof p.hasVariants === "boolean"
          ? p.hasVariants
          : Array.isArray(p.variants) && p.variants.length > 0,
      availabilityLabel: p.availabilityLabel || p.availability || "",
      availabilityAmount: p.availabilityAmount || "",
      availabilityColor: p.availabilityColor || "",
    };

    const rvItem = `
      <div class="product lastWiew">
        <div class="p" data-micro="product" data-testid="productItem">
          <a href="${product.url}" class="image">
            <img src="${product.image}" data-src="${product.secondImage || ""}" alt="${product.name}" loading="lazy">
              <div class="flags flags-default">${product.flags || ""}</div>
              <div class="flags flags-extra">${getFlagsExtraHtml(product)}</div>
          </a>
          <div class="p-in">
            <div class="p-in-in">
              <a href="${product.url}" class="name" data-micro="url">
                <span data-micro="name" data-testid="productCardName">${product.name}</span>
              </a>
              <div class="ratings-wrapper">${getAvailabilityHtml(product)}</div>
            </div>
            <div class="p-bottom single-button no-buttons">
              <div data-micro="offer">
                <div class="prices">  ${product.priceStandard ? `<span class="price-standard"><span>${product.priceStandard}</span></span>` : ""}
               
                  <span class="price price-final"><strong>${product.price || ""}</strong></span>
                </div>
                <div class="p-tools">
                  ${product.hasVariants
        ? `<a href="${product.url}" class="btn btn-primary" aria-hidden="true" tabindex="0">Detail produktu</a>`
        : `<form action="/action/Cart/addCartItem/" method="post" class="pr-action csrf-enabled">
  <input type="hidden" name="language" value="cs" tabindex="0">
 <input type="hidden" name="productId" value="${product.product_id}" tabindex="0">
 <input type="hidden" name="priceId" value="${product.priceId || product.product_id}" tabindex="0">
 <input type="hidden" name="amount" value="1" autocomplete="off" tabindex="0">
    <button type="submit" class="btn btn-cart add-to-cart-button">
        <span>Do košíku</span>
    </button>
  </form>`
      }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    $rvList.append(rvItem);
  });

  $rvList
    .find(".product .image")
    .off("mouseenter.recentImage mouseleave.recentImage")
    .hover(
      function () {
        const $img = $(this).find("img");

        $img.data("original-src", $img.attr("src"));

        const newSrc = $img.attr("data-src");
        if (newSrc) {
          $img.attr("src", newSrc);
        }
      },
      function () {
        const $img = $(this).find("img");

        const originalSrc = $img.data("original-src");
        if (originalSrc) {
          $img.attr("src", originalSrc);
        }
      },
    );
}
if ($(".type-detail").length) {
  addProductToStorage();
}
